import React from "react";

/**
 * @component ArrowDownIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ArrowDownIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowDownIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="ArrowDownIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M15.372 10.264a.993.993 0 011.349 0 .867.867 0 010 1.275L12 16l-4.72-4.461a.867.867 0 010-1.275.993.993 0 011.348 0L12 13.451l3.372-3.187z"
      />
    </svg>
  )
);
ArrowDownIcon.displayName = "ArrowDownIcon";
export default ArrowDownIcon;
